module.exports = __webpack_public_path__ + "img/failure.24d6bd7a.jpg";